import { createReducer } from "@reduxjs/toolkit";
import { RouterStateInterface } from "../actions/Router/types";
import { setCurrentAndPreviousRoute } from "actions";

const initialState: RouterStateInterface = {
    routeDetails: {
        prev: "",
        current: ""
    }
};

const router = createReducer(initialState, (builder) => {
    builder
        .addCase(setCurrentAndPreviousRoute, (state, action) => {
            state.routeDetails.prev = state.routeDetails.current;
            state.routeDetails.current = action.payload.data;
        })
        .addDefaultCase((state) => state);
});

export default router;
